<template>
  <div class="form-grid" ref="grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DdFormGrid",
  props:{
    cols: Number,
  },
  mounted(){
    if (this.cols > 2) return;
    if ( this.cols ) this.$refs.grid.style.gridTemplateColumns = `repeat(${this.cols}, 1fr)`
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.form-grid {
  display: grid;
  grid-gap: $spacing-md;
  grid-template-columns: repeat(1, 1fr);
}
</style>
